module.exports = __webpack_public_path__ + "static/media/overpass-bold-italic.a3014aca.woff2";